import { IConfig } from '@microsoft/esign.gateway.service.client';
import * as React from 'react';
import { useESignApprovalsQuery } from '../../utilities/ApolloRestUtils';
import { getEsignGatewayConfiguration } from '../../views/Esign/utils/Authentication/EsignAuthHelpers';
import ApprovalsListContext from '../ApprovalsListContext/ApprovalsListContext';
import { ApprovalsListProviderProps } from '../ApprovalsListContext/ApprovalsListProviderProps';
import { convertESignDataToApprovalsListItems } from './helpers/convertESignDataToApprovalsListItems';

/**
 * ESignApprovalsListProvider - gets data for the Syntex approvals type
 */
export default ({ listData, children }: ApprovalsListProviderProps): JSX.Element => {
    const {
        data: approvalsData,
        loading,
        error,
        fetchMoreItems,
        hasMoreItems,
        refetch,
    } = useESignApprovalsQuery(listData, 'cache-and-network');
    const [items, setItems] = React.useState([]);

    // config is empty for esign approvals
    const config = {};

    // Only recalculate list items when approvals data has changed, to keep the same reference possible
    React.useEffect((): void => {
        getEsignGatewayConfiguration(listData.approvalType).then((configuration: IConfig): void => {
            const approvalListItems = convertESignDataToApprovalsListItems(
                approvalsData?.ListESignApprovals?.signingRequests,
                listData.approvalType,
                configuration.providerUserId
            );
            setItems(approvalListItems);
        });
    }, [approvalsData?.ListESignApprovals?.signingRequests, listData.approvalType]);

    return (
        <ApprovalsListContext.Provider value={{ loading, error, fetchMoreItems, hasMoreItems, refetch, config, items }}>
            {children}
        </ApprovalsListContext.Provider>
    );
};
